import useModal from '@/hooks/useModal';
import React from 'react';
import { ModalHeader } from '../ModalHeader';
import { Button, Typography, TypographyType } from '@/components/common';

interface Props {
	isOpen: boolean;
	setIsOpen: (value: boolean) => void;
	title?: string;
	typography?: TypographyType;
	description?: string | React.ReactElement;
	titleCancel?: string;
	titleConfirm?: string;
	onCancel?: () => void;
	onConfirm: () => void;
}

export const ConfirmModal: React.FC<Props> = ({
	title = 'Confirm action',
	typography = 'regular-16',
	description = "You're about to...",
	titleCancel = 'Cancel',
	titleConfirm = 'Confirm',
	onCancel,
	onConfirm,
	isOpen,
	setIsOpen,
}) => {
	const { Modal, show, hide } = useModal();

	React.useEffect(() => {
		if (isOpen) {
			show();
		} else {
			hide();
		}
	}, [isOpen]);

	const handleCancel = () => {
		hide();
		setIsOpen(false);
		onCancel?.();
	};

	const handleConfirm = () => {
		onConfirm();
		hide();
		setIsOpen(false);
	};

	return (
		<Modal
			withXButton
			title={<ModalHeader title={title} />}
			onClose={handleCancel}
			classNameCardContainer="!w-[486px]"
			classNameContainerChildren="space-y-8 mt-8"
		>
			{typeof description === 'string' ? (
				<Typography type={typography}>{description}</Typography>
			) : (
				description
			)}

			<div className="flex items-center justify-center gap-2">
				<Button
					size="fit"
					type="button"
					decoration="secondary"
					onClick={handleCancel}
				>
					{titleCancel}
				</Button>
				<Button
					size="fit"
					type="button"
					decoration="primary"
					onClick={handleConfirm}
				>
					{titleConfirm}
				</Button>
			</div>
		</Modal>
	);
};
